/**
 * api/overview.ts —— 运营总览（§五 5.9）
 *
 * 🔴 **只有一个接口，一次拿整页**。Hero、矩阵、最近活动必须来自同一次请求——
 *   拆成三次就会出现「Hero 说已提交 10 支、矩阵里数出来 9 支」这种谁都解释不清的状态。
 * ⚠ 这一页**一个数都不许前端算**（红线 4）：平均进度、提交率、逾期支数、落后期数、
 *   「几天前」全部由服务端算好下发。看到这里出现 reduce / 日期减法就是口径分叉的开始。
 * ⚠ **排序也在服务端**：前端只按出参里的 `sort` / `dir` 高亮表头。
 */
import { get, type ReqOptions } from './client.js';
import type { OverviewSortKey, OverviewView } from '@shared-types';

export const overview = (
  sort: OverviewSortKey,
  dir: 'asc' | 'desc',
  opts?: ReqOptions,
): Promise<OverviewView> => {
  const p = new URLSearchParams({ sort, dir });
  return get<OverviewView>(`/api/overview?${p.toString()}`, opts);
};
